<app-stripe-billing (errorEmitter)="onError($event)" [customer]="customer" [stripeBillingIn]="stripeBilling" [isCustomerProfile]="true"></app-stripe-billing>
<div class="ui-g ui-g-12">
  @if (error) {
    <div class="ui-g-12">
      <div id="errors" role="alert" class="alert alert-danger" style="text-align:left">{{ error }}</div>
    </div>
  }
</div>